import { colors } from 'src/components/styled/theme/constants/colors';

/**
 * Categorical series colors for distinguishing several things at once (e.g.
 * vehicles on a map). The first entry matches the theme accent, so a single
 * series looks like the rest of the UI. Dark variants are lighter to keep
 * contrast against dark surfaces.
 */
export const categoricalLight = Object.freeze([
    colors.Blue4,
    '#E8590C',
    colors.Green5,
    '#7C3AED',
    colors.Red3,
    '#0E7C86',
    '#B7791F',
    '#C2185B',
]);

export const categoricalDark = Object.freeze([
    colors.Blue3,
    '#FF922B',
    colors.Green3,
    '#B197FC',
    colors.Red2,
    '#3BC9DB',
    '#FCC419',
    '#F783AC',
]);
